<template>
    <div>
        <main-layout-content>
            <template #content>
                <common-content-spacer height="medium">
                    <common-page-header
                        size="large"
                        :heading="$t('pages.terms.terms.heading')"
                        :isCenter="true"
                    ></common-page-header>
                    <div class="agrement-page">
                        <common-content-spacer height="medium">
                            <div class="agrement-page__links">
                                <b v-html="$t('pages.terms.terms.privacy_policy_link')"></b>
                                <b v-html="$t('pages.terms.terms.disclaimer_link')"></b>
                            </div>
                            <div>{{ $t('pages.terms.terms.updated') }}</div>

                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.introduction') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.welcome_message') }}</p>
                                <p>
                                    {{ $t('pages.terms.terms.terms_of_service') }}
                                </p>
                                <p v-html="$t('pages.terms.terms.privacy_policy')"></p>
                                <p v-html="$t('pages.terms.terms.agreements')"></p>
                                <p>
                                    {{ $t('pages.terms.terms.disagreement_message') }}
                                </p>
                            </div>

                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.communications') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.purchase_information') }}
                                </p>
                            </div>

                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.purchases') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.purchase_information') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.user_represent_warranty') }}
                                </p>
                                <p v-html="$t('pages.terms.terms.third_party_services')"></p>
                                <p>
                                    {{ $t('pages.terms.terms.order_refusal_reasons') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.order_refusal_fraud') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.contests_promotions') }}</b>
                                </p>
                                <p v-html="$t('pages.terms.terms.promotions_description')"></p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.subscriptions') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.subscriptions_description_1') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.subscriptions_description_2') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.subscriptions_description_3') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.subscriptions_description_4') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.free_trial') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.free_trial_description_1') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.free_trial_description_2') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.free_trial_description_3') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.fee_changes') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.fee_changes_description_1') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.fee_changes_description_2') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.fee_changes_description_3') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.refunds') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.refunds_description') }}</p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.content') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.content_description_1') }}</p>
                                <p>{{ $t('pages.terms.terms.content_description_2') }}</p>
                                <p>{{ $t('pages.terms.terms.content_description_3') }}</p>
                                <p>{{ $t('pages.terms.terms.content_description_4') }}</p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.prohibited_uses') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_1') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_2') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_3') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_4') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_5') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_6') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_7') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_8') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_9') }}</p>
                                <p>{{ $t('pages.terms.terms.prohibited_uses_description_10') }}</p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.analytics') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.analytics_description') }}</p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.no_use_by_minors') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.no_use_by_minors_description') }}</p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.accounts') }}</b>
                                </p>
                                <p>{{ $t('pages.terms.terms.accounts_description') }}</p>
                            </div>

                            {{ $t('pages.terms.terms.responsible') }}
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.intellectual_property') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.intellectual_property_description_1') }}
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.intellectual_property_description_2') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.copyright_policy') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.copyright_policy_description') }}
                                </p>
                            </div>
                            {{ $t('pages.terms.terms.copyright_claim_intro') }}
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.dmca_notice') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.dmca_notice_description_1') }}
                                </p>
                                <ol>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_1') }}</li>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_2') }}</li>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_3') }}</li>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_4') }}</li>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_5') }}</li>
                                    <li>{{ $t('pages.terms.terms.dmca_notice_item_6') }}</li>
                                </ol>
                                <p>
                                    {{ $t('pages.terms.terms.dmca_notice_description_2') }}
                                </p>
                                <div>
                                    <p>
                                        <b>{{ $t('pages.terms.terms.error_reporting_feedback') }}</b>
                                    </p>
                                    <p>
                                        {{ $t('pages.terms.terms.error_reporting_feedback_description') }}
                                    </p>
                                    <p>
                                        {{ $t('pages.terms.terms.error_reporting_feedback_description_2') }}
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        <b>{{ $t('pages.terms.terms.links_to_other_websites') }}</b>
                                    </p>
                                    <p>
                                        {{ $t('pages.terms.terms.links_to_other_websites_description') }}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.disclaimer') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.disclaimer_description') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.warranty_disclaimer') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.warranty_disclaimer_description') }}
                                </p>
                            </div>
                            {{ $t('pages.terms.terms.warranty_claim_intro') }}
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.limitation_of_liability') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.limitation_of_liability_description') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.termination') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.termination_description') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.governing_law') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.governing_law_description') }}
                                </p>
                            </div>
                            {{ $t('pages.terms.terms.enforcement_note') }}
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.image_upload_terms_and_conditions') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.image_upload_terms_and_conditions_description') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.acknowledgement') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.acknowledgement_description') }}
                                </p>
                            </div>
                            <div>
                                <p>
                                    <b>{{ $t('pages.terms.terms.contact_us') }}</b>
                                </p>
                                <p>
                                    {{ $t('pages.terms.terms.contact_us_description') }}
                                </p>
                            </div>

                            <div>
                                <p><b></b></p>
                            </div>
                        </common-content-spacer>
                    </div>
                </common-content-spacer>
            </template>
        </main-layout-content>
    </div>
</template>
<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    export default {
        components: { MainLayoutContent },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .agrement-page {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 50px;
        max-width: 70%;
        margin: 0 auto;
        @include breakpoint(tablet) {
            max-width: 85%;
        }
        @include breakpoint(smartphone-large) {
            max-width: 100%;
        }
        &__links {
            display: flex;
            justify-content: space-evenly;
            @include breakpoint(smartphone-large) {
                justify-content: space-between;
            }
        }

        a {
            color: $color-link;
        }
    }
</style>
